import React from "react";
import AcMonitoring from "../Pages/AcMonitoring";
import "./home.css";

const Acmonitor = () => {
  return (
    <section className='home'>
      <div className='container'>
        <div className='heading flexSB'>
          <div className="flex items-center">            
          </div>
        </div>
        <AcMonitoring />
      </div>
    </section>
  );
}

export default Acmonitor;
